export interface Character {
  slug: string;
  name: string;
  workSlug: string;
  workName: string;
  role: string;
  title: string;
  tags: string[];
  race: string;
  intro: string;
  personality: string;
  cp: string;
  cpDesc: string;
  popularity: number;
  avatar: string;
  featured?: boolean;
}

export const characters: Character[] = [
  {
    slug: "yin-xiyue",
    name: "尹汐月",
    workSlug: "yueye-yaohua",
    workName: "月夜妖华",
    role: "女主",
    title: "月下衔铃的小猫妖",
    tags: ["猫耳", "娇气大小姐", "傲娇", "反差萌"],
    race: "猫妖",
    intro:
      "《月夜妖华》的女主角，月庭山庄捡回来的银发猫妖。白天是慵懒撒娇的软团子，一到月圆之夜便会现出猫耳与长尾，性格也骤然变得高傲挑剔，是全剧反差感最强的女主之一。",
    personality:
      "表面娇气爱耍小性子，实则重情重义。对身边人护短得厉害，嘴上说着不要，行动上却总在偷偷帮忙，是典型的『傲娇没头脑』与『温柔行动派』结合的讨喜人设。",
    cp: "白钰（青梅竹马·月庭少主）",
    cpDesc: "欢喜冤家式官配，从小一起长大，一个爱闹一个爱宠，日常拌嘴却总在危难时互为依靠，CP热度常年稳居站内前三。",
    popularity: 98,
    avatar: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20illustration%20of%20a%20cute%20cat-eared%20fairy%20girl%20with%20long%20silver%20hair%20and%20soft%20pink%20accents%2C%20big%20sparkling%20amber%20eyes%2C%20wearing%20an%20elegant%20pale%20pastel%20hanbok%20style%20dress%2C%20gentle%20dreamy%20expression%2C%20soft%20pastel%20moonlit%20background%2C%20romantic%20fantasy%20style%2C%20high%20quality%20anime%20portrait&width=720&height=960&seq=char-xiyue&orientation=portrait",
    featured: true,
  },
  {
    slug: "jiang-mengluo",
    name: "姜梦萝",
    workSlug: "humian-wangfei",
    workName: "狐面王妃",
    role: "女主",
    title: "九尾狐面下的小王妃",
    tags: ["九尾狐", "温柔腹黑", "御姐", "谋略型"],
    race: "九尾狐",
    intro:
      "《狐面王妃》的女主角，为报灭族之仇入宫成为王妃的九尾狐。戴着一副狐面示人，人前温婉贤良，人后运筹帷幄，是妖精漫画里少见的『双面谋略型』女主。",
    personality:
      "外表温柔似水，内心冷静坚韧。所有算计都只为守护身边人，虽然腹黑却从不伤害无辜，恩怨分明，被读者称为『最会哭也最能扛』的王妃大人。",
    cp: "玄渊（冷面帝王）",
    cpDesc: "从互相试探到生死相托，帝王与狐妃的推拉博弈张力拉满，车与刀的刀光剑影里全是糖，是站内讨论量最高的CP之一。",
    popularity: 96,
    avatar: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20portrait%20of%20an%20elegant%20nine-tailed%20fox%20queen%20with%20long%20crimson%20hair%2C%20wearing%20a%20luxurious%20red%20and%20gold%20royal%20hanbok%2C%20holding%20a%20white%20fox%20mask%2C%20mysterious%20charming%20gaze%2C%20ornate%20palace%20background%20with%20soft%20warm%20lighting%2C%20romantic%20fantasy%20webtoon%20style%2C%20high%20quality%20anime%20portrait&width=720&height=960&seq=char-mengluo&orientation=portrait",
    featured: true,
  },
  {
    slug: "lin-qianxue",
    name: "林千雪",
    workSlug: "bingyue-huajia",
    workName: "冰月花嫁",
    role: "女主",
    title: "冰封雪国的冷艳公主",
    tags: ["冰雪", "清冷女王", "高岭之花", "成长系"],
    race: "雪女/冰灵",
    intro:
      "《冰月花嫁》的女主角，生于永冬之国的冰灵公主。天生体温冰冷、情感淡薄，却在联姻途中一点点学会心动，是『高岭之花坠落凡尘』的经典成长型女主。",
    personality:
      "冷静克制、清冷疏离，话不多却句句温柔。不擅长表达情感，用别扭的方式关心所有人，越到后期越让人心疼，是站内『希望她幸福』呼声最高的女主。",
    cp: "陆之遥（温暖花妖）",
    cpDesc: "冰与火、寒与暖的极致碰撞。花妖用一整个春天的温度慢慢融化冰雪公主，慢热治愈向CP，糖分不高但后劲十足。",
    popularity: 93,
    avatar: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20portrait%20of%20a%20beautiful%20snow%20princess%20with%20flowing%20ice-blue%20hair%20and%20pale%20skin%2C%20wearing%20a%20white%20and%20silver%20ice%20themed%20gown%2C%20cold%20yet%20gentle%20expression%2C%20snowflake%20and%20frost%20background%2C%20dreamy%20cold%20palette%2C%20romantic%20fantasy%20webtoon%20style%2C%20high%20quality%20anime%20portrait&width=720&height=960&seq=char-qianxue&orientation=portrait",
  },
  {
    slug: "piao-xiaen",
    name: "朴夏恩",
    workSlug: "yese-bianlidian",
    workName: "夜色便利店",
    role: "女主",
    title: "守夜人妖的元气店长",
    tags: ["元气", "打工仔", "天然", "治愈系"],
    race: "人类（店长）",
    intro:
      "《夜色便利店》的女主角，经营着一家只在夜晚营业、专供妖怪购物的便利店。白天是普通上班族，夜里摇身一变成为最受欢迎的妖精便利店店长。",
    personality:
      "精力旺盛、乐观开朗，天大的事都能被她笑着化解。看似没心没肺，实则细腻体贴，记得每位妖怪顾客的喜好，是整条夜街的『小太阳』。",
    cp: "夜枭（神秘常客）",
    cpDesc: "笨蛋人类店长 × 高冷神秘妖客，日常互怼又互相收留，治愈日常里藏着细水长流的温柔，被读者调侃『便利店的糖不要钱』。",
    popularity: 91,
    avatar: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20portrait%20of%20an%20energetic%20young%20shop%20owner%20girl%20with%20short%20brown%20bob%20hair%20and%20a%20bright%20smile%2C%20wearing%20a%20cozy%20hoodie%20and%20apron%2C%20holding%20a%20warm%20drink%2C%20cozy%20night%20convenience%20store%20background%20with%20warm%20glow%2C%20cute%20and%20lively%20webtoon%20style%2C%20high%20quality%20anime%20portrait&width=720&height=960&seq=char-xiaen&orientation=portrait",
  },
  {
    slug: "cui-ninger",
    name: "崔宁儿",
    workSlug: "yinghua-yaoqi",
    workName: "樱花妖契",
    role: "女主",
    title: "与少年签订契约的樱花精灵",
    tags: ["软萌", "治愈", "天然呆", "契约妖"],
    race: "樱花精灵",
    intro:
      "《樱花妖契》的女主角，因被少年所救而主动献上契约的樱花精灵。温柔到近乎没有脾气，把『守护』两个字写进骨子里，是全作最柔软的存在。",
    personality:
      "软软糯糯、心思纯净，总能一眼看穿他人难过的小情绪。胆子很小却很勇敢，只要是为了想保护的人，再怕也会往前冲。",
    cp: "顾言（契约少年）",
    cpDesc: "献契与救赎双向奔赴，少年治愈她的孤独，她回报以毫无保留的温柔。纯爱治愈向，泪点与糖点并存。",
    popularity: 90,
    avatar: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20portrait%20of%20a%20soft%20and%20cute%20sakura%20spirit%20girl%20with%20long%20light-pink%20hair%20and%20flower%20decorations%2C%20wearing%20a%20fluffy%20pastel%20kimono%20style%20outfit%2C%20warm%20gentle%20eyes%20and%20timid%20smile%2C%20cherry%20blossom%20petals%20floating%20background%2C%20soft%20dreamy%20lighting%2C%20romantic%20fantasy%20webtoon%20style%2C%20high%20quality%20anime%20portrait&width=720&height=960&seq=char-ninger&orientation=portrait",
  },
  {
    slug: "bai-huji",
    name: "白狐姬",
    workSlug: "shanhai-lingge",
    workName: "山海灵歌",
    role: "女主",
    title: "误入人间的山海小灵兽",
    tags: ["天然呆", "灵兽", "软萌", "吃货"],
    race: "山海灵兽",
    intro:
      "《山海灵歌》的女主角，从《山海经》里跑出来的小灵兽，误打误撞来到人间。什么都不懂却什么都好奇，是全场『移动的可爱』担当。",
    personality:
      "天真烂漫、毫无心机，认准一个道理就一条道走到黑。贪吃又爱玩，却对认下的人掏心掏肺，呆萌外表下藏着纯粹的善意。",
    cp: "林泽（温和人师）",
    cpDesc: "人师与小灵兽的师徒羁绊逐渐发酵，教她人间烟火，她带他重拾热爱，温吞治愈的养成系CP。",
    popularity: 87,
    avatar: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20portrait%20of%20a%20playful%20little%20white%20fox%20spirit%20girl%20with%20white%20hair%20and%20fluffy%20fox%20ears%20and%20tail%2C%20innocent%20sparkling%20eyes%2C%20eating%20a%20rice%20ball%20happily%2C%20wearing%20a%20bright%20red%20traditional%20hanbok%2C%20vibrant%20mythical%20forest%20background%2C%20cute%20lively%20webtoon%20style%2C%20high%20quality%20anime%20portrait&width=720&height=960&seq=char-huji&orientation=portrait",
  },
  {
    slug: "song-zhao",
    name: "宋昭",
    workSlug: "fenghuang-niepan",
    workName: "凤凰涅槃",
    role: "女主",
    title: "涅槃重生的凤族大小姐",
    tags: ["傲娇", "凤族", "高智商", "女王"],
    race: "凤凰",
    intro:
      "《凤凰涅槃》的女主角，凤族备受宠爱的掌上明珠。一朝遭难经历涅槃，从骄傲张扬到沉稳内敛，完成了从大小姐到女王的华丽蜕变。",
    personality:
      "骄傲又清醒，嘴上不饶人却比谁都拎得清。涅槃后多了一分冷冽与果决，对敌人毫不手软，对爱人却笨拙得可爱。",
    cp: "厉寒（腹黑对手）",
    cpDesc: "强强对峙型CP，旗鼓相当的两个人从针锋相对到生死相托，试探、博弈、暧昧全部拉满，张力十足。",
    popularity: 89,
    avatar: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20portrait%20of%20a%20proud%20phoenix%20clan%20princess%20with%20flowing%20vermilion%20red%20hair%20and%20golden%20phoenix%20ornaments%2C%20sharp%20confident%20gaze%2C%20wearing%20a%20stunning%20red%20and%20gold%20gown%20with%20feather%20details%2C%20dramatic%20fire%20and%20phoenix%20background%2C%20bold%20romantic%20fantasy%20webtoon%20style%2C%20high%20quality%20anime%20portrait&width=720&height=960&seq=char-songzhao&orientation=portrait",
  },
  {
    slug: "tengyuan-shaling",
    name: "藤原纱绫",
    workSlug: "wudu-yaotan",
    workName: "雾都妖谭",
    role: "女主",
    title: "游走雾都的冷静阴阳师",
    tags: ["御姐", "阴阳师", "冷静", "高冷"],
    race: "人类（阴阳师）",
    intro:
      "《雾都妖谭》的女主角，白天是普通高中教师，夜里是游走于雾都解决妖怪委托的阴阳师。冷静、专业、神秘，是都市怪谈里的『定海神针』。",
    personality:
      "沉稳理智、克制内敛，几乎从不情绪失控。看似疏离，却默默守护着整座雾都的妖怪与人，越了解越被她藏在冷淡下的温柔打动。",
    cp: "雾弥（雾妖）",
    cpDesc: "人与妖的界限在她面前慢慢模糊，一个负责降妖，一个负责被她降服，克制又汹涌的都市慢热CP。",
    popularity: 88,
    avatar: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20portrait%20of%20a%20calm%20cool%20female%20exorcist%20with%20long%20black%20hair%20and%20fringe%2C%20wearing%20a%20dark%20modern%20kimono%20with%20an%20ominous%20seal%20motif%2C%20holding%20a%20paper%20talisman%2C%20composed%20expression%2C%20misty%20dark%20city%20night%20background%2C%20mysterious%20moody%20webtoon%20style%2C%20high%20quality%20anime%20portrait&width=720&height=960&seq=char-shaling&orientation=portrait",
  },
  {
    slug: "zheng-xiaoman",
    name: "郑小满",
    workSlug: "xingguang-shitang",
    workName: "星光食堂",
    role: "女主",
    title: "用料理治愈妖怪的精灵厨师",
    tags: ["治愈", "厨师", "元气", "反差萌"],
    race: "精灵",
    intro:
      "《星光食堂》的女主角，在妖怪界开了一家深夜食堂的精灵厨师。一人一店一灶，用一道道料理抚慰着来来往往妖怪的心事与伤痕。",
    personality:
      "温柔治愈、善解人意，厨艺与直觉一样精准。平时安静话少，一提到料理就两眼放光，反差萌十足。",
    cp: "阿岚（常驻食客·狼妖）",
    cpDesc: "每夜准时到店的狼妖与老板娘之间的温暖羁绊，美食与日常交织，细水长流的治愈向CP。",
    popularity: 86,
    avatar: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20portrait%20of%20a%20gentle%20healing%20elf%20chef%20girl%20with%20long%20green%20hair%20and%20pointed%20ears%2C%20wearing%20a%20warm%20apron%20over%20a%20soft%20cream%20outfit%2C%20holding%20a%20steaming%20bowl%20of%20soup%2C%20soft%20warm%20smile%2C%20cozy%20warm%20restaurant%20kitchen%20background%2C%20healing%20cute%20webtoon%20style%2C%20high%20quality%20anime%20portrait&width=720&height=960&seq=char-xiaoman&orientation=portrait",
  },
  {
    slug: "li-hanyi",
    name: "李寒衣",
    workSlug: "hanyue-jiange",
    workName: "寒月剑歌",
    role: "女主",
    title: "一柄寒剑闯江湖的飒爽剑妖",
    tags: ["飒爽", "剑妖", "侠女", "外冷内热"],
    race: "剑妖",
    intro:
      "《寒月剑歌》的女女主角，由千年寒剑化形的剑妖。初时冷若冰霜，只知剑不懂情，直到遇见那人，才学会了何为心动。",
    personality:
      "洒脱利落、宁折不弯，认定的事九头牛也拉不回。看似疏离淡漠，实则外冷内热，把在意的人默默放在心底最柔软处。",
    cp: "沈聿（江湖浪子）",
    cpDesc: "剑妖与浪子的江湖同行，一个守剑一个守心，从并肩到并肩，飒爽中藏着最隐晦也最动人的温柔。",
    popularity: 85,
    avatar: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20portrait%20of%20a%20cool%20and%20heroic%20sword%20spirit%20girl%20with%20flowing%20black%20hair%20tied%20high%20and%20sharp%20eyes%2C%20holding%20a%20frost%20covered%20sword%2C%20wearing%20a%20white%20and%20blue%20wuxia%20outfit%2C%20moonlit%20mountain%20background%20with%20falling%20snow%2C%20wuxia%20romantic%20fantasy%20webtoon%20style%2C%20high%20quality%20anime%20portrait&width=720&height=960&seq=char-hanyi&orientation=portrait",
  },
];

export const characterRaces: string[] = [
  "全部",
  "妖灵",
  "神族",
  "半妖",
  "人类",
  "魔物",
];

export const characterTags: string[] = [
  "全部",
  "傲娇",
  "软萌",
  "温柔",
  "腹黑",
  "御姐",
  "元气",
  "清冷",
  "天然呆",
  "飒爽",
];

export function getCharacter(slug: string): Character | undefined {
  return characters.find((c) => c.slug === slug);
}